<template>
    <div class="w-full flex flex-col gap-4 items-center p-5">
        <section class="white-rounded-box w-1/2 mx-auto p-7">
            <h1 class="pb-2.5">Invite Contacts to Salesium</h1>
            <div class="mt-5 mb-5">
                <a href="/" class="px-10 py-3 my-3 rounded-lg bg-salesium-blue text-white" style="text-decoration:none;">Skip</a>
            </div>
            <hr />
            <p class="pt-2">
                Enter a single email or upload a CSV file that includes contact
                name and email.
            </p>
            <p class="py-2">
                By clicking to upload and invite the selected contacts you
                assert that you have gained appropriate authorization either
                through prior relationship or proactive consent to both have
                access to and message the listed contacts.
            </p>

            <div class="mb-4 flex flex-col">
                <!-- single contact invite -->
                <span class="h-52" v-show="!showingUploadForm">
                    <span class="mt-2 flex flex-col">
                        Email
                        <t-input
                            v-model="email"
                            type="email"
                            placeholder="your-contact@your-company.com"
                        />
                    </span>
                    <span class="my-2 flex flex-col">
                        Name
                        <t-input v-model="name" placeholder="Contact name" />
                    </span>
                    <span>
                        Invite this contact upon adding
                        <t-checkbox class="ml-2" v-model="invite" />
                    </span>
                </span>

                <!-- bulk upload form -->
                <span class="h-52 flex flex-col" v-show="showingUploadForm">
                    <p class="pt-2">
                        Note: Your CSV file should have the contact email as the
                        first column and the contact name as the second column.
                    </p>
                    <span class="mt-1.5 flex flex-col">
                        CSV File
                        <t-input
                            class="mt-1.5"
                            ref="fileUploadField"
                            type="file"
                            @change="fileChanged"
                            placeholder="Contact CSV file"
                            accept=".csv"
                        />
                    </span>
                    <span class="mt-2">
                        Invite all contacts upon uploading
                        <t-checkbox class="ml-2" v-model="invite" />
                    </span>
                    <t-alert class="mt-2" variant="danger" :show="showError">
                        {{ errorMessage }}
                    </t-alert>
                </span>

                <!-- action buttons -->
                <div class="flex">
                    <button
                        v-if="!showingUploadForm"
                        @click="addContacts"
                        class="px-10 py-3 my-3 rounded-lg bg-salesium-blue text-white"
                    >
                        Add Contact
                    </button>
                    <button
                        v-else
                        @click="addContacts"
                        class="px-10 py-3 my-3 rounded-lg bg-salesium-blue text-white"
                    >
                        Upload
                    </button>
                    <span class="ml-auto flex items-center justify-center">
                        {{
                            showingUploadForm
                                ? "Switch to single add"
                                : "Switch to Bulk upload"
                        }}
                        <t-toggle class="ml-5" v-model="showingUploadForm" />
                    </span>
                </div>
            </div>
            <hr />
            <InviteList
                @new-data="getInvites"
                v-show="allInvites.length > 0"
                :invites="allInvites"
                :length="length"
            />
        </section>
        <a v-show="canSkip" href="/">Go to Dashboard</a>
    </div>
</template>
<script>
import InviteList from "./partials/InviteList.vue";

export default {
    data() {
        return {
            email: "",
            name: "",
            invite: false,
            allInvites: [],
            showingUploadForm: false,
            file: null,
            contacts: [],
            showError: false,
            errorMessage: "",
        };
    },
    props: ["user", "canSkip"],
    computed: {
        length: {
            get() {
                return this.allInvites.length;
            },
        },
    },
    methods: {
        async addContacts() {
            // split email input if multiples passed in
            if (!this.showingUploadForm) {
                this.contacts = [
                    {
                        invite: this.invite,
                        email: this.email,
                        name: this.name,
                    },
                ];
            } else {
                if(this.file == null){
                    this.errorMessage = "Please select a file.";
                    this.showError = true;
                }else{
                    this.errorMessage = "";
                    this.showError = false;
                    await this.parseFile().catch(() => alert("Something went wrong!") );
                }
            }
            await window.axios
                .post("/api/invitation/addFromContacts", {
                    contacts: this.showingUploadForm
                        ? this.contacts
                        : [
                              {
                                  invite: this.invite,
                                  email: this.email,
                                  name: this.name,
                              },
                          ],
                })
                .catch((error) => {
                    console.log(error);
                    alert("Something went wrong!");
                });
            this.$refs["fileUploadField"].value = null;
            this.file = null;
            this.email = "";
            this.name = "";
            this.getInvites();
        },
        async getInvites() {
            const response = await window.axios.get("/api/invitation/all");
            this.allInvites = response.data.data;
        },
        async parseFile() {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = (e) => {
                    let fileContent = reader.result;
                    let lines = fileContent.split(/\r\n|\n/);

                    // for csv only
                    let headers = lines[0].split(",");

                    this.contacts = [];

                    // if (lines.slice(1).length > 100) {
                    //     this.showError = true;
                    //     this.errorMessage =
                    //         "You can only upload 100 contacts at a time.";
                    // } else {
                        this.showError = false;
                        this.errorMessage = "";
                        for (const contact of lines.slice(1)) {
                            if(contact.split(",")[0] == null || contact.split(",")[0] == "")
                            {
                                continue;
                            }
                            this.contacts.push({
                                invite: null,
                                email: contact.split(",")[0],
                                name: contact.split(",")[1],
                            });
                        }
                        resolve();
                    // }
                };
                reader.onerror = (e) => {
                    reject(e);
                };
                reader.readAsText(this.file);
            });
        },
        fileChanged(e) {
            this.file = e.target.files[0];
        },
    },
    mounted() {
        this.getInvites();
    },
    components: { InviteList },
};
</script>
